import bindAll from 'lodash.bindall';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import {connect} from 'react-redux';
import {compose} from 'redux';

import Box from '../components/box/box.jsx';
import GUI from '../containers/gui.jsx';
import HashParserHOC from '../lib/hash-parser-hoc.jsx';
import AppStateHOC from '../lib/app-state-hoc.jsx';
import TitledHOC from '../lib/titled-hoc.jsx';
import log from '../lib/log';
import {setPlayer} from '../reducers/mode';
import {openLoadingProject, closeLoadingProject} from '../reducers/modals';
import {openZuopin, getaliossfile,getaliossfileOld} from '../service/zuopin';
import {
    LoadingStates,
    getIsLoadingUpload,
    onLoadedProject,
    requestProjectUpload
} from '../reducers/project-state';
import {weixin_GetSign_url, ali_header_url, ali_json_files_path} from '../util/constants.js';

if (process.env.NODE_ENV === 'production' && typeof window === 'object') {
    // Warn before navigating away
    // window.onbeforeunload = () => true;
}
import styles from './player.css';
import {getQueryString, isPC} from '../util/tools.js';
import PubSub from 'pubsub-js';
// import Base64 from 'base-64';
import {Base64} from 'js-base64';
import {fileToString} from '../util/handleFile';

import Loader from '../components/loader/loader-player.jsx';
import {getZuopinInfo} from '../service/zuopin';
import {selectLocale} from '../reducers/locales';
import {closeLanguageMenu} from '../reducers/menus';

class Player extends React.PureComponent {

    constructor (props) {
        super(props);
        this.state = {
            showLoader: true
        };
        bindAll(
            this, [
                'getJSSdk',
                'get_wx_config',
                'updateWechatShare',
                'IsPC'
            ]
        );
        this.getJSSdk();
    }

    componentDidMount () {

        // const newLocale = 'zh-cn';
        // this.props.onChangeLanguage(newLocale);
        // document.documentElement.lang = newLocale;

        this.get_wx_config();
        // let fileId = getQueryString('fileid');
        // sessionStorage.setItem('fileid', fileId);
        // let stagesize = getQueryString('stagesize');
        // sessionStorage.setItem('stagesize', stagesize);
        // let json_filename = getQueryString('json_filename');
        // let status_json = getQueryString('status_json');

        // document.title = decodeURI(Base64.decode(getQueryString('title'))) + '-' + decodeURI(Base64.decode(getQueryString('name')));

        //add 点赞相关
        sessionStorage.removeItem('fenxiang_code');
        sessionStorage.removeItem('stage-header');

        sessionStorage.removeItem('zuopin_img_share');
        sessionStorage.removeItem('sharezuopinjson');
        sessionStorage.removeItem('fenxiang_code');



        let fenxiang_code = getQueryString('fenxiang_code');
        sessionStorage.setItem('fenxiang_code', fenxiang_code);
        PubSub.publish('fenxiang_code', fenxiang_code);

        let header_status = getQueryString('header_status');
        sessionStorage.setItem('header_status', header_status);

        if (header_status === '0') {
            PubSub.publish('header_status', '');
        }

        // if (stagesize === '1') {
        //     PubSub.publish('stage-size', 'big');
        // }
        // if (stagesize === '2') {
        //     PubSub.publish('stage-size', 'small');
        // }

        //add打开分享的作品
        sessionStorage.setItem('firstSharePlay', '1');
        console.log('给firstSharePlay存值');

        this.setState({
            showLoader: true
        });

        sessionStorage.setItem('openzuopin', '1');


        console.log(this.Navigator())

        // console.log(Base64.encode('000000000000000000000000000000'));
        // console.log(encodeURIComponent('我的测试作品'));
        // console.log(encodeURIComponent('https://spark-app.oss-cn-qingdao.aliyuncs.com/ziyuan/files/chengxuwenjian/wenjian/%E6%8E%A8%E7%AE%B1%E5%AD%90%E6%B8%B8%E6%88%8F-2021_12_9-%E4%B8%8A%E5%8D%8811_09_53.aispark'));
        // console.log(encodeURIComponent('张老师'));

        if(fenxiang_code=='xixin'){
            let name = Base64.decode(getQueryString('name'));
            let fileurl = Base64.decode(getQueryString('fileurl'));
            let title = Base64.decode(getQueryString('title'));

            console.log('title=='+title)

             sessionStorage.setItem('school_name_share', '');
             sessionStorage.setItem('author_name_share', name);
             // sessionStorage.setItem('zuopin_img_share', zuopin_img);
             // sessionStorage.setItem('zuopin_title_share', zuopin_img);
             //document.title = title + '-' + name;

            document.title = Base64.decode(getQueryString('title')) + '-' + Base64.decode(getQueryString('name'));


            getaliossfileOld(fileurl, (data) => {
                this.props.vm.loadProject(data)
                    .then(() => {
                        this.props.closeLoadingState();
                        this.setState({
                            showLoader: false
                        });
                    })
                    .catch(error => {
                        log.warn(error);
                        this.props.closeLoadingState();
                        this.setState({
                            showLoader: false
                        });
                    });
            });
        }else{
            getZuopinInfo(fenxiang_code, (data) => {
                console.log(data);
                if (data.ret == '1') {
                    var status_json = data.data.zuopin_info.status_json;
                    var fileId = data.data.zuopin_info.file_name;
                    var author_name = data.data.zuopin_info.author_name;
                    var author_username = data.data.zuopin_info.author_username;
                    var json_filename = data.data.zuopin_info.json_filename;
                    var school_name = data.data.zuopin_info.school_name;
                    var stagesize = data.data.zuopin_info.stagesize;
                    var zuopin_code = data.data.zuopin_info.zuopin_code;
                    var zuopin_title = data.data.zuopin_info.title;
                    var zuopin_img = data.data.zuopin_info.zuopin_img;

                    sessionStorage.setItem('fileid', fileId);
                    sessionStorage.setItem('stagesize', stagesize);
                    //add 点赞相关
                    // sessionStorage.removeItem('fenxiang_code');
                    // sessionStorage.removeItem('stage-header');

                    sessionStorage.setItem('school_name_share', school_name);
                    sessionStorage.setItem('author_name_share', author_name);
                    sessionStorage.setItem('zuopin_img_share', zuopin_img);
                    sessionStorage.setItem('zuopin_title_share', zuopin_img);


                    document.title = zuopin_title + '-' + author_name;

                    PubSub.publish('zuopin_img_share', zuopin_img);

                    PubSub.publish('zuopin_img_share', zuopin_img);

                    if (stagesize === '1') {
                        PubSub.publish('stage-size', 'big');
                    }
                    if (stagesize === '2') {
                        PubSub.publish('stage-size', 'small');
                    }


                    if (status_json == 0) {
                        openZuopin(fileId, (data) => {
                            getaliossfileOld(data.data, (data) => {
                                this.props.vm.loadProject(data)
                                    .then(() => {
                                        this.props.closeLoadingState();
                                        this.setState({
                                            showLoader: false
                                        });
                                    })
                                    .catch(error => {
                                        log.warn(error);
                                        this.props.closeLoadingState();
                                        this.setState({
                                            showLoader: false
                                        });
                                    });
                            });
                        });
                    }
                    else {
                        var json_file_path = `${ali_header_url}${ali_json_files_path}${json_filename}`;
                        getaliossfileOld(json_file_path, (data) => {
                            fileToString(data, (data) => {
                                this.props.vm.loadProject(data)
                                    .then(() => {

                                        console.log('分享作品加载完成');

                                        this.props.closeLoadingState();
                                        this.setState({
                                            showLoader: false
                                        });

                                    })
                                    .catch(error => {
                                        this.props.closeLoadingState();
                                        this.setState({
                                            showLoader: false
                                        });
                                    });
                            });
                        });
                    }

                }
            });
        }


        // getZuopinInfo(fenxiang_code, (data) => {
        //     console.log(data);
        //     if (data.ret == '1') {
        //         var status_json = data.data.zuopin_info.status_json;
        //         var fileId = data.data.zuopin_info.file_name;
        //         var author_name = data.data.zuopin_info.author_name;
        //         var author_username = data.data.zuopin_info.author_username;
        //         var json_filename = data.data.zuopin_info.json_filename;
        //         var school_name = data.data.zuopin_info.school_name;
        //         var stagesize = data.data.zuopin_info.stagesize;
        //         var zuopin_code = data.data.zuopin_info.zuopin_code;
        //         var zuopin_title = data.data.zuopin_info.title;
        //         var zuopin_img = data.data.zuopin_info.zuopin_img;
        //
        //         sessionStorage.setItem('fileid', fileId);
        //         sessionStorage.setItem('stagesize', stagesize);
        //         //add 点赞相关
        //         // sessionStorage.removeItem('fenxiang_code');
        //         // sessionStorage.removeItem('stage-header');
        //
        //         sessionStorage.setItem('school_name_share', school_name);
        //         sessionStorage.setItem('author_name_share', author_name);
        //         sessionStorage.setItem('zuopin_img_share', zuopin_img);
        //         sessionStorage.setItem('zuopin_title_share', zuopin_img);
        //
        //
        //         document.title = zuopin_title + '-' + author_name;
        //
        //         PubSub.publish('zuopin_img_share', zuopin_img);
        //
        //         PubSub.publish('zuopin_img_share', zuopin_img);
        //
        //         if (stagesize === '1') {
        //             PubSub.publish('stage-size', 'big');
        //         }
        //         if (stagesize === '2') {
        //             PubSub.publish('stage-size', 'small');
        //         }
        //
        //
        //         if (status_json == 0) {
        //             openZuopin(fileId, (data) => {
        //                 getaliossfile(data.data, (data) => {
        //                     this.props.vm.loadProject(data)
        //                         .then(() => {
        //                             this.props.closeLoadingState();
        //                             this.setState({
        //                                 showLoader: false
        //                             });
        //                         })
        //                         .catch(error => {
        //                             log.warn(error);
        //                             this.props.closeLoadingState();
        //                             this.setState({
        //                                 showLoader: false
        //                             });
        //                         });
        //                 });
        //             });
        //         }
        //         else {
        //             var json_file_path = `${ali_header_url}${ali_json_files_path}${json_filename}`;
        //             getaliossfile(json_file_path, (data) => {
        //                 fileToString(data, (data) => {
        //                     this.props.vm.loadProject(data)
        //                         .then(() => {
        //
        //                             console.log('分享作品加载完成');
        //
        //                             this.props.closeLoadingState();
        //                             this.setState({
        //                                 showLoader: false
        //                             });
        //
        //                         })
        //                         .catch(error => {
        //                             this.props.closeLoadingState();
        //                             this.setState({
        //                                 showLoader: false
        //                             });
        //                         });
        //                 });
        //             });
        //         }
        //
        //     }
        // });
    }

    Navigator(){
        var Sys = {},
            ua = navigator.userAgent.toLowerCase(),
            s;

        (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :

            (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :

                (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :

                    (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :

                        (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;

        //以下进行测试
        var appName,appVersion;

        if(Sys.ie){
            appName ="IE";
            appVersion= Sys.ie;
        }

        if(Sys.firefox){
            appName ="Firefox";
            appVersion= Sys.firefox;
        }

        if(Sys.chrome){
            appName ="Chrome";
            appVersion= Sys.chrome;
        }

        if(Sys.opera){
            appName ="Opera";
            appVersion= Sys.opera;
        }

        if(Sys.safari){
            appName ="Safari";
            appVersion= Sys.safari;
        }

        //console.log ({"appName":appName ,"appVersion":appVersion})
        return {"appName":appName ,"appVersion":appVersion}

    }

    getJSSdk () {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://spark-app.oss-cn-qingdao.aliyuncs.com/aispark/jweixin-1.4.0.js';
        document.head.appendChild(script);

        var script1 = document.createElement('script');
        script1.type = 'text/javascript';
        script1.async = true;
        script1.src = 'https://spark-app.oss-cn-qingdao.aliyuncs.com/aispark/jquery-3.1.1.min.js';
        document.head.appendChild(script1);
    }

    get_wx_config () {
        //url（当前网页的URL，不包含#及其后面部分）
         var url = window.location.href.split('#')[0];
        //var url = window.location.href;

        let formData = new FormData();
        formData.append('appurl', url);

        var that = this;
        fetch(weixin_GetSign_url, {
            method: 'POST',
            body: formData,
            dataType: 'json'
        })
            .then(
                function (response) {
                    if (response.status !== 200) {
                        console.log('存在一个问题，状态码为：' + response.status);
                        return;
                    }
                    //检查响应文本
                    response.json()
                        .then(function (result) {
                            wx.config({
                                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                                appId: result.appId,   // 必填，公众号的唯一标识
                                timestamp: result.timestamp, // 必填，生成签名的时间戳
                                nonceStr: result.nonceStr, // 必填，生成签名的随机串
                                signature: result.signature,// 必填，签名，见附录1
                                jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                                // 基本思路是，上传图片到微信服务器->下载多媒体接口讲图片下载到服务器->返回服务器存储路径->前台显示
                            });
                            wx.ready(function (res) {
                                if (!that.IsPC()) {
                                    setTimeout(that.updateWechatShare, 200);
                                }
                            });

                            wx.error(function (res) {
                                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，
                                // 也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                            });
                        });
                }
            )
            .catch(function (err) {
                console.log('Fetch错误:' + err);
            });
    }

    updateWechatShare () {
        wx.updateAppMessageShareData({
            title: sessionStorage.getItem('zuopin_title_share') + '-' + sessionStorage.getItem('author_name_share'), // 分享标题
            desc: '我在AISpark创作的人工智能作品，你来试试吧', // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://aispark.gamepku.com/static/favicon.ico', // 分享图标
            success: function () {
                // 设置成功
            },
            fail: function (e) {
            }
        });

        wx.updateTimelineShareData({
            title: sessionStorage.getItem('zuopin_title_share') + '-' + sessionStorage.getItem('author_name_share'), // 分享标题
            desc: '我在AISpark创作的人工智能作品，你来试试吧', // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: 'https://aispark.gamepku.com/static/favicon.ico', // 分享图标
            success: function () {
                // 设置成功
            },
            fail: function (e) {
            }
        });

    }

    IsPC () {
        //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
        var ua = window.navigator.userAgent.toLowerCase();
        //通过正则表达式匹配ua中是否含有MicroMessenger字符串
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return false;
        } else {
            return true;
        }
    }

    render () {
        let {isPlayerOnly, onSeeInside, projectId} = this.props;
        return (
            <Box
                className={classNames({
                    [styles.stageOnly]: isPlayerOnly
                })}
            >
                {this.state.showLoader ? <Loader/> : null}


                <GUI
                    enableCommunity
                    isPlayerOnly={isPlayerOnly}
                    projectId={projectId}
                />
            </Box>
        );
    }
}


Player.propTypes = {
    isPlayerOnly: PropTypes.bool,
    onSeeInside: PropTypes.func,
    projectId: PropTypes.string,
    loadingState: PropTypes.oneOf(LoadingStates),
    onLoadingFinished: PropTypes.func,
    onLoadingStarted: PropTypes.func,
    onUpdateProjectTitle: PropTypes.func,
    vm: PropTypes.shape({
        loadProject: PropTypes.func
    })
};

const mapStateToProps = state => ({
    isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
    loadingState: state.scratchGui.projectState.loadingState,
    vm: state.scratchGui.vm
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    onLoadingFinished: (loadingState, success) => {
        dispatch(onLoadedProject(loadingState, ownProps.canSave, success));
        dispatch(closeLoadingProject());
    },
    onSeeInside: () => dispatch(setPlayer(false)),
    onLoadingStarted: () => dispatch(openLoadingProject()),
    closeLoadingState: () => dispatch(closeLoadingProject()),
    openLoadingState: () => dispatch(openLoadingProject()),
    onChangeLanguage: locale => {
        dispatch(selectLocale(locale));
        dispatch(closeLanguageMenu());
    },
});

const ConnectedPlayer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Player);


// note that redux's 'compose' function is just being used as a general utility to make
// the hierarchy of HOC constructor calls clearer here; it has nothing to do with redux's
// ability to compose reducers.
const WrappedPlayer = compose(
    AppStateHOC,
    HashParserHOC,
    TitledHOC
)(ConnectedPlayer);

const appTarget = document.createElement('div');
document.body.appendChild(appTarget);

ReactDOM.render(<WrappedPlayer isPlayerOnly={true} isFullScreen={true}/>, appTarget);
